class PdvService {

    GetPlaces() {
        let response = window.__pt.pdvdata;

        if (response) {
            let branchesActive = response.branchs.filter(item => item.active);

            let sortedStates = response.states.sort((a, b) => a.name.localeCompare(b.name));

            response.branchs = branchesActive;
            response.states = sortedStates;
            response.dispatch = {
                path: ""
            }
            return response;
        }

        return {
            branchs: [],
            states: [],
            dispatch: {},
            message: null,
            status: 404
        }
    }
}

export const PdvServices = new PdvService();